module.exports = __webpack_public_path__ + "surveys-icon.png?b99ccaf6bd27dd855385c3cd935b3db5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/surveys-icon.png
// module id = 119
// module chunks = 0